/// <reference path="/js/viz/map/views/SelectedRegionSummaryView.js"/>
/// <reference path="/js/viz/util/Fips.js"/>

(function($, _) {
  var ns = window.nspace("ccc.viz.map.views");

  /**
   * Displays the "NYC summary" view on the right hand side of the map that
   * shows data for New York City for the current selections, if available
   */
  ns.NYCSummaryView = ns.SelectedRegionSummaryView.extend({
    el: "#nyc-summary-container",
    name: "NYCSummaryView",
    sparklineContainerId: "nyc-chart-container",

    getCurrentFips: function() {
      return ccc.viz.util.Fips.NYC;
    },

    render: function() {
      // Don't bother rerendering if the only thing that changed was the selected region
      if (
        _.size(this.model.changed) === 1 &&
        this.model.changed.hasOwnProperty("selectedFips")
      ) {
        return;
      }

      // Call the base implementation
      ns.NYCSummaryView.__super__.render.call(this);
    },

    overrideDisplayValues: function(displayVals) {
      var response = this.dataResponseModel.get("response");
      var tfId = this.model.get("timeFrameId");

      displayVals.rankSubtext = "In " + response.timeFramesById[tfId].name;
    }
  });
})(jQuery, _);
